import ICON_CLOSE_LIGHT from '../../../../public/static/icon-close-light.svg';
import ICON_CLOSE from '../../../../public/static/icon-close.svg';
import ICON_NOTICE_LIGHT from '../../../../public/static/icon-notice-light.svg';
import ICON_NOTICE_NEW_LIGHT from '../../../../public/static/icon-notice-new-light.svg';
import ICON_NOTICE_NEW from '../../../../public/static/icon-notice-new.svg';
import ICON_NOTICE from '../../../../public/static/icon-notice.svg';
import ICON_BACK_LIGHT from '../../../../public/static/v4/common/icon-back-light.svg';
import ICON_BACK from '../../../../public/static/v4/common/icon-back.svg';
import useTheme from '../../hook/useTheme';
import {IButtonIcon} from '../../type';

interface IProps {
  icon: Exclude<IButtonIcon, 'close'>;
  isOnlyDarkMode: boolean;
}

export default function LeftIcon({icon, isOnlyDarkMode}: IProps) {
  const {getSrc, width, height, alt} = ICON_VARIANT_MAP[icon];
  const {isLightMode} = useTheme();
  return (
    <img
      src={getSrc(isOnlyDarkMode ? false : isLightMode)}
      alt={alt}
      width={width}
      height={height}
    />
  );
}

const ICON_VARIANT_MAP: {
  [key in IButtonIcon]: {
    width: string;
    height: string;
    getSrc: (isLightMode: boolean) => string;
    alt: string;
  };
} = {
  close: {
    width: '24px',
    height: '24px',
    getSrc: isLightMode => (isLightMode ? ICON_CLOSE_LIGHT : ICON_CLOSE),
    alt: 'close',
  },
  back: {
    width: '32px',
    height: '24px',
    getSrc: isLightMode => (isLightMode ? ICON_BACK_LIGHT : ICON_BACK),
    alt: 'back',
  },
  notice: {
    width: '24px',
    height: '24px',
    getSrc: isLightMode => (isLightMode ? ICON_NOTICE_LIGHT : ICON_NOTICE),
    alt: 'notice',
  },
  newNotice: {
    width: '24px',
    height: '24px',
    getSrc: isLightMode =>
      isLightMode ? ICON_NOTICE_NEW_LIGHT : ICON_NOTICE_NEW,
    alt: 'newNotice',
  },
};
